import { render, staticRenderFns } from "./dangjianindex.vue?vue&type=template&id=f6a29300&"
import script from "./dangjianindex.vue?vue&type=script&lang=js&"
export * from "./dangjianindex.vue?vue&type=script&lang=js&"
import style0 from "./dangjianindex.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports